import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const translations = {
  fr: {
    // Splash
    splash_tagline: "Le réseau mondial des cartes cadeaux",
    splash_enter: "Entrer",
    splash_footer: "2000+ boutiques · Mondial · Sur invitation",
    
    // Nav
    nav_layers: "Les 3 couches",
    nav_gift_cards: "Cartes Cadeaux",
    nav_gift_cards_desc: "Offrir · Recevoir · Recharger",
    nav_payment_card: "Carte de Paiement",
    nav_payment_card_desc: "Payer · Relevé mensuel",
    nav_crypto: "Paiement Crypto",
    nav_crypto_desc: "BTC · ETH · USDC · SOL · IKA",
    nav_discover: "Découvrir",
    nav_home: "Accueil",
    nav_network: "Réseau mondial",
    nav_loyalty: "Programme fidélité",
    nav_about: "À propos",
    nav_contact: "Contact",
    nav_login: "Connexion",
    nav_gift: "Offrir",
    nav_footer: "Sur invitation uniquement",
    nav_global_shops: "2000+ boutiques · Mondial",
    
    // Hero
    hero_badge: "Réseau privé sur invitation",
    hero_title_1: "Une carte.",
    hero_title_2: "Tout un réseau.",
    hero_subtitle: "Carte cadeau, carte fidélité, carte de paiement — c'est la même. Rechargez en fiat ou crypto. Utilisez dans 2000+ boutiques à travers le monde.",
    hero_cta: "Offrir une carte cadeau",
    hero_cta_secondary: "Comprendre le concept",
    hero_received: "Vous avez reçu une carte ?",
    hero_activate: "Activez-la ici",
    
    // Stats
    stats_shops: "Boutiques",
    stats_countries: "Pays",
    stats_members: "Membres",
    
    // Sections
    section_concept: "Le concept",
    section_one_card: "Une seule carte, trois usages",
    section_one_card_desc: "Pas besoin de comprendre la différence — c'est la même carte.",
    
    card_gift: "Carte Cadeau",
    card_gift_desc: "Offrez-la à quelqu'un. C'est son ticket d'entrée dans le réseau.",
    card_loyalty: "Carte Fidélité",
    card_loyalty_desc: "Chaque achat rapporte des points. 100 pts = 1€.",
    card_payment: "Carte Paiement",
    card_payment_desc: "Rechargez-la et payez dans toutes les boutiques du réseau.",
    
    // Join
    section_join: "Comment rejoindre",
    section_invitation: "Sur invitation uniquement",
    section_invitation_desc: "habitué est un réseau privé. Pour devenir membre, quelqu'un doit vous offrir une carte cadeau.",
    
    join_step1_title: "Recevez une carte cadeau",
    join_step1_desc: "Un ami, un proche ou une boutique vous offre une carte habitué.",
    join_step2_title: "Activez votre compte",
    join_step2_desc: "Scannez le QR code et créez votre compte en 30 secondes.",
    join_step3_title: "Utilisez & Partagez",
    join_step3_desc: "Dépensez, gagnez des points, et offrez des cartes à votre tour.",
    
    no_card_yet: "Vous n'avez pas encore de carte ?",
    request_invitation: "Demander une invitation",
    
    // Top up
    section_topup: "Rechargement",
    section_topup_title: "Rechargez comme vous voulez",
    section_topup_desc: "Votre carte est rechargeable à tout moment. En ligne, 24h/24. Avec votre carte bancaire ou vos cryptomonnaies.",
    topup_card: "Carte bancaire",
    topup_card_desc: "Visa, Mastercard, Amex",
    topup_crypto: "Crypto",
    topup_crypto_desc: "BTC, ETH, USDC, SOL, IKA — conversion automatique",
    topup_no_fees: "Pas de frais sur les rechargements en fiat. 1% sur les conversions crypto.",
    topup_amounts: "Montants de recharge",
    topup_custom: "Ou montant personnalisé",
    
    // Network
    section_network_badge: "Réseau fermé · Mondial",
    section_network_title: "2000+ boutiques à travers le monde",
    section_network_desc: "Votre carte habitué fonctionne exclusivement dans notre réseau de boutiques partenaires — Paris, Londres, New York, Tokyo, Dubai et plus encore.",
    explore_network: "Explorer le réseau mondial",
    
    // Loyalty
    section_loyalty: "Fidélité",
    section_loyalty_title: "Plus vous utilisez, plus vous gagnez",
    points_per: "points",
    points_by: "par",
    points_spent: "dépensé",
    points_value: "de crédit sur votre carte",
    points: "points",
    
    // Merchants
    section_merchants: "Commerçants",
    section_merchants_title: "Rejoignez le réseau",
    section_merchants_desc: "Fidélisez vos clients sans effort. Installation en 10 minutes. Acceptez les paiements habitué et attirez une nouvelle clientèle mondiale.",
    merchants_qr: "QR code à afficher — rien d'autre",
    merchants_dashboard: "Dashboard temps réel",
    merchants_commission: "Commission uniquement sur les ventes",
    merchants_trial: "90 jours gratuits pour tester",
    become_partner: "Devenir partenaire",
    pricing: "Tarifs",
    trial: "Essai",
    trial_free: "90 jours gratuits",
    commission_note: "+ 5% commission sur les cartes émises",
    
    // Final CTA
    final_title_1: "Faites plaisir.",
    final_title_2: "Partagez habitué.",
    final_desc: "Offrez une carte cadeau à quelqu'un que vous aimez. C'est son entrée dans le réseau.",
    final_cta: "Offrir une carte cadeau",
    have_card: "J'ai déjà une carte",
    
    // Footer
    footer_tagline: "Le réseau privé mondial des cartes cadeaux.",
    footer_members: "Membres",
    footer_activate: "Activer ma carte",
    footer_gift: "Offrir une carte",
    footer_shops: "Boutiques",
    footer_company: "Entreprise",
    footer_merchants: "Marchands",
    footer_pricing: "Tarifs",
    footer_partner: "Devenir partenaire",
    footer_rights: "Tous droits réservés.",
    footer_love: "Fait avec ♥ à Paris",
    
    // Payment Card Page
    payment_layer: "Couche paiement",
    payment_title_1: "Payez partout.",
    payment_title_2: "Sans friction.",
    payment_subtitle: "Votre carte habitué est aussi une carte de paiement. Rechargez-la et utilisez-la dans tout le réseau.",
    payment_card_label: "CARTE DE PAIEMENT",
    balance: "SOLDE",
    payment_features: "Fonctionnalités",
    payment_features_title: "Un paiement simple et sécurisé",
    payment_instant: "Paiement instantané",
    payment_instant_desc: "Scannez un QR code ou présentez votre téléphone pour payer.",
    payment_secure: "Sécurité bancaire",
    payment_secure_desc: "Transactions cryptées, aucune donnée carte stockée.",
    payment_statement: "Relevé mensuel",
    payment_statement_desc: "Suivez vos dépenses avec des rapports détaillés.",
    payment_topup: "Recharge facile",
    payment_topup_desc: "Rechargez par carte, virement ou crypto.",
    payment_tiers: "Niveaux",
    payment_tiers_title: "Un niveau pour chaque usage",
    limit: "Limite",
    tier_basic_payments: "Paiements dans le réseau",
    tier_2pts: "2 pts par £1 dépensé",
    tier_3pts: "3 pts par £1 dépensé",
    tier_4pts: "4 pts par £1 dépensé",
    tier_network_access: "Accès au réseau mondial",
    tier_priority_support: "Support prioritaire",
    tier_exclusive_offers: "Offres exclusives",
    tier_concierge: "Service conciergerie",
    tier_vip_events: "Événements VIP",
    no_fees: "Sans frais",
    crypto_fee: "1% de frais de conversion",
    payment_cta_title: "Prêt à payer avec habitué ?",
    payment_cta_desc: "Activez votre carte et commencez à l'utiliser dans tout le réseau.",
    activate_my_card: "Activer ma carte",
    
    // Crypto Page
    crypto_layer: "Couche crypto",
    crypto_title_1: "Vos cryptos.",
    crypto_title_2: "Votre carte.",
    crypto_subtitle: "Rechargez votre carte habitué avec Bitcoin, Ethereum, USDC, Solana ou IKA. Conversion automatique en £.",
    crypto_supported: "Cryptos acceptées",
    crypto_supported_title: "5 cryptomonnaies disponibles",
    crypto_btc_desc: "Le standard",
    crypto_eth_desc: "Smart contracts",
    crypto_usdc_desc: "Stablecoin USD",
    crypto_sol_desc: "Rapide & économique",
    crypto_ika_desc: "Natif habitué",
    crypto_how_it_works: "Comment ça marche",
    crypto_how_title: "Recharger en 4 étapes",
    crypto_step_1: "Choisissez votre crypto",
    crypto_step_2: "Entrez le montant",
    crypto_step_3: "Envoyez à l'adresse",
    crypto_step_4: "Crédit instantané",
    crypto_instant_conversion: "Conversion instantanée",
    crypto_instant_conversion_desc: "Votre crypto est convertie en £ au taux du marché.",
    crypto_secure: "Sécurisé",
    crypto_secure_desc: "Transactions vérifiées sur la blockchain.",
    crypto_low_fees: "Frais réduits",
    crypto_low_fees_desc: "Seulement 1% de frais de conversion.",
    crypto_24_7: "Disponible 24/7",
    crypto_24_7_desc: "Rechargez à tout moment, n'importe où.",
    crypto_conversion_title: "Conversion automatique",
    crypto_conversion_desc: "Votre crypto est instantanément convertie en £ sur votre carte habitué. Pas de volatilité, pas de surprise.",
    crypto_benefit_1: "Taux de marché en temps réel",
    crypto_benefit_2: "Crédit instantané sur votre carte",
    crypto_benefit_3: "Historique complet des transactions",
    crypto_fee_note: "1% de frais de conversion uniquement",
    crypto_cta_title: "Prêt à utiliser vos cryptos ?",
    crypto_cta_desc: "Activez votre carte et rechargez avec vos cryptomonnaies préférées.",
    
    // Loyalty Page
    loyalty_layer: "Programme fidélité",
    loyalty_title_1: "Gagnez.",
    loyalty_title_2: "À chaque achat.",
    loyalty_subtitle: "Chaque dépense dans le réseau habitué vous rapporte des points. Plus vous utilisez, plus vous gagnez.",
    loyalty_how_points: "Comment fonctionnent les points ?",
    loyalty_credit: "de crédit",
    loyalty_credit_desc: "Utilisable dans tout le réseau comme de l'argent.",
    loyalty_tiers: "Niveaux de fidélité",
    loyalty_tiers_title: "Trois statuts exclusifs",
    loyalty_earn_rate: "Taux de gain",
    loyalty_member_b1: "Accès au réseau mondial",
    loyalty_member_b2: "Paiements illimités",
    loyalty_member_b3: "Historique de transactions",
    loyalty_reserve_b1: "Tout de Member, plus...",
    loyalty_reserve_b2: "Support prioritaire",
    loyalty_reserve_b3: "Offres exclusives",
    loyalty_reserve_b4: "Invitations en avant-première",
    loyalty_founding_b1: "Tout de Reserve, plus...",
    loyalty_founding_b2: "Service conciergerie",
    loyalty_founding_b3: "Événements VIP",
    loyalty_founding_b4: "Badge Founding exclusif",
    loyalty_founding_b5: "Cadeaux anniversaire",
    loyalty_ways_earn: "Façons de gagner",
    loyalty_ways_title: "Accumulez des points facilement",
    loyalty_way_1_title: "Achats dans le réseau",
    loyalty_way_1_desc: "Gagnez des points à chaque achat chez nos partenaires.",
    loyalty_way_2_title: "Offrez des cartes",
    loyalty_way_2_desc: "Bonus de 50 pts pour chaque carte cadeau offerte.",
    loyalty_way_3_title: "Parrainage",
    loyalty_way_3_desc: "100 pts quand votre filleul active sa carte.",
    loyalty_track_progress: "Suivez votre progression",
    loyalty_your_points: "Vos points actuels",
    loyalty_to_reserve: "points avant Reserve",
    loyalty_cta_title: "Commencez à gagner dès maintenant",
    loyalty_cta_desc: "Chaque achat vous rapproche du niveau suivant.",
    
    // Gift Offer Page
    gift_badge: "Offrir une carte",
    gift_title_1: "Faites plaisir.",
    gift_title_2: "Offrez l'accès au réseau.",
    gift_subtitle: "Une carte cadeau habitué, c'est l'entrée dans un réseau privé de boutiques exceptionnelles.",
    gift_card_label: "CARTE CADEAU",
    gift_value: "VALEUR",
    gift_feature_1: "Valable dans 2000+ boutiques",
    gift_feature_2: "Livraison instantanée par email",
    gift_feature_3: "Validité 24 mois",
    gift_feature_4: "Le destinataire gagne des points",
    gift_step_1_title: "Choisissez un montant",
    gift_custom: "Autre",
    gift_continue: "Continuer",
    gift_step_2_title: "Destinataire",
    gift_recipient_name: "Nom du destinataire",
    gift_recipient_email: "Email du destinataire",
    gift_message: "Message personnel (optionnel)",
    gift_message_placeholder: "Joyeux anniversaire ! J'espère que tu trouveras ton bonheur...",
    gift_back: "Retour",
    gift_step_3_title: "Paiement",
    gift_card_value: "Valeur de la carte",
    gift_fees: "Frais",
    gift_free: "Gratuit",
    gift_total: "Total",
    gift_card_number: "Numéro de carte",
    gift_expiry: "Expiration",
    gift_secure_payment: "Paiement sécurisé via Stripe",
    gift_send: "Envoyer le cadeau",
    gift_note: "Le destinataire recevra un email avec sa carte et un lien pour créer son compte.",
    
    // Activate Page
    activate_badge: "Activer une carte",
    activate_title_1: "Activez votre carte.",
    activate_title_2: "Rejoignez le réseau.",
    activate_subtitle: "Vous avez reçu une carte cadeau habitué ? Activez-la en quelques secondes.",
    activate_step_1_label: "Scanner",
    activate_step_2_label: "Créer un compte",
    activate_step_3_label: "Terminé",
    activate_scan_title: "Scannez votre carte",
    activate_scan_desc: "Scannez le QR code présent sur votre carte cadeau",
    activate_open_camera: "Ouvrir la caméra",
    activate_or: "ou",
    activate_enter_code: "Entrez le code de la carte",
    activate_verify: "Vérifier",
    activate_found_title: "Carte trouvée !",
    activate_found_desc: "Créez votre compte pour l'activer.",
    activate_card_value: "Valeur de la carte",
    activate_from: "Offerte par",
    activate_create_account: "Créez votre compte",
    activate_name: "Votre nom",
    activate_email: "Votre email",
    activate_password: "Mot de passe",
    activate_create_btn: "Créer mon compte",
    activate_success_title: "Bienvenue dans le réseau !",
    activate_success_desc: "Votre carte est maintenant active.",
    activate_card_balance: "Solde de la carte",
    activate_points: "Points fidélité",
    activate_tier: "Niveau",
    activate_go_wallet: "Accéder à mon wallet",
    activate_welcome_message: "Bienvenue dans le réseau habitué !",
    activate_no_card: "Vous n'avez pas encore reçu de carte ?",
    
    // Error messages
    error_enter_code: "Veuillez entrer un code d'invitation",
    error_invalid_code: "Code d'invitation invalide ou expiré",
    error_fill_all_fields: "Veuillez remplir tous les champs obligatoires",
    error_password_min: "Le mot de passe doit contenir au moins 6 caractères",
    error_activation_failed: "Échec de l'activation. Veuillez réessayer.",
    loading: "Chargement...",
    
    // About Page
    about_badge: "Notre histoire",
    about_title_1: "Réinventer la fidélité,",
    about_title_2: "ensemble",
    about_desc: "habitué est né d'une frustration simple : pourquoi avoir 15 cartes de fidélité quand une seule pourrait tout faire ? Nous avons créé le réseau qui réunit vos commerces préférés sous une même bannière.",
    about_mission_badge: "Notre mission",
    about_mission_title: "Créer du lien entre les commerces et leurs clients",
    about_mission_p1: "Nous pensons que la fidélité ne devrait pas être compliquée. Pas de points qui expirent, pas de conditions illisibles, pas de cartes perdues au fond d'un tiroir.",
    about_mission_p2: "Avec habitué, chaque visite compte, chaque point a de la valeur, et chaque membre fait partie d'une communauté qui célèbre le commerce local.",
    about_values_badge: "Nos valeurs",
    about_values_title: "Ce qui nous guide",
    about_value_1_title: "Passion du local",
    about_value_1_desc: "Nous croyons en la force des commerces de proximité et en leur capacité à créer du lien.",
    about_value_2_title: "Transparence",
    about_value_2_desc: "Pas de frais cachés, pas de conditions obscures. Ce qui est dit est fait.",
    about_value_3_title: "Simplicité",
    about_value_3_desc: "Une technologie invisible au service de l'expérience. Pas de gadgets inutiles.",
    about_value_4_title: "Communauté",
    about_value_4_desc: "Un réseau où chaque membre, client ou marchand, trouve sa place et sa valeur.",
    about_timeline_badge: "Notre parcours",
    about_timeline_title: "Une aventure qui commence",
    about_milestone_1_year: "2024",
    about_milestone_1_event: "Naissance de l'idée",
    about_milestone_1_desc: "Frustration des cartes de fidélité multiples",
    about_milestone_2_year: "2024",
    about_milestone_2_event: "Premiers marchands",
    about_milestone_2_desc: "10 commerces parisiens nous font confiance",
    about_milestone_3_year: "2025",
    about_milestone_3_event: "Lancement public",
    about_milestone_3_desc: "habitué ouvre ses portes à tous",
    about_milestone_4_year: "2025",
    about_milestone_4_event: "150+ marchands",
    about_milestone_4_desc: "Le réseau s'étend dans toute la France",
    about_team_badge: "L'équipe",
    about_team_title: "Les visages derrière habitué",
    about_cta_title: "Rejoignez l'aventure",
    about_cta_desc: "Que vous soyez client ou marchand, il y a une place pour vous dans le réseau habitué.",
    about_cta_member: "Devenir membre",
    about_cta_contact: "Nous contacter",
    about_stat_merchants: "Marchands",
    about_stat_members: "Membres",
    about_stat_scans: "Scans",
    about_stat_satisfaction: "Satisfaction",
    
    // Benefits Page
    benefits_badge: "Écosystème complet",
    benefits_title_1: "Trois couches,",
    benefits_title_2: "un seul compte",
    benefits_subtitle: "Cartes cadeaux · Charge Card propriétaire · Paiement crypto. Une plateforme complète pour les membres et les marchands.",
    benefits_tab_loyalty: "Fidélité",
    benefits_tab_card: "Charge Card",
    benefits_tab_crypto: "Crypto",
    benefits_how_earn: "Comment gagner des points",
    benefits_pts_network: "Chez les marchands habitué",
    benefits_pts_elsewhere: "Partout ailleurs",
    benefits_pts_value: "De crédit utilisable",
    benefits_tier_member: "Votre entrée dans le réseau",
    benefits_tier_reserve: "Pour les habitués fidèles",
    benefits_tier_founding: "L'élite du réseau habitué",
    benefits_exclusive: "Exclusif",
    benefits_card_hero_badge: "Couche 2 · Réseau propriétaire",
    benefits_card_title: "habitué Charge Card",
    benefits_card_desc: "Carte de paiement propriétaire. Solde intégral payable chaque mois. Pas de crédit revolving, pas de taux d'intérêt.",
    benefits_card_obsidian: "Noir mat premium",
    benefits_card_creme: "Élégance intemporelle",
    benefits_card_forest: "British Racing Green",
    benefits_card_gold: "Métal · Édition Fondateurs",
    benefits_card_limited: "Limited",
    benefits_card_feature_1: "Réseau mondial",
    benefits_card_feature_1_desc: "Acceptance via partenariats d'acquisition. Pas Visa/Mastercard.",
    benefits_card_feature_2: "Pas de dette",
    benefits_card_feature_2_desc: "Charge card — solde intégral payable chaque mois. Zéro intérêt.",
    benefits_card_feature_3: "FX compétitif",
    benefits_card_feature_3_desc: "Marge de 1.5% sur les transactions hors GBP.",
    benefits_card_fees_title: "Frais annuels",
    benefits_card_fees_standard: "Standard",
    benefits_card_fees_gold: "Or Métal",
    benefits_card_fees_merchant: "Frais d'acceptance marchand : 1.5% – 2.0%",
    benefits_crypto_badge: "Couche 3 · Zéro exposition marchand",
    benefits_crypto_title: "Paiement Crypto",
    benefits_crypto_desc: "Payez en crypto, le marchand reçoit des GBP. Conversion instantanée au point de vente.",
    benefits_crypto_supported: "Cryptos acceptées",
    benefits_crypto_btc: "Le standard",
    benefits_crypto_eth: "Smart contracts",
    benefits_crypto_usdc: "Stablecoin USD",
    benefits_crypto_sol: "Rapide & économique",
    benefits_crypto_how_title: "Comment ça marche",
    benefits_crypto_step_1: "Vous payez",
    benefits_crypto_step_1_desc: "En BTC, ETH ou USDC depuis votre wallet",
    benefits_crypto_step_2: "Conversion",
    benefits_crypto_step_2_desc: "Instantanée en GBP au taux du marché",
    benefits_crypto_step_3: "Marchand reçoit",
    benefits_crypto_step_3_desc: "Des livres sterling, zéro volatilité",
    benefits_crypto_key_1: "Même taux de points qu'un paiement fiat",
    benefits_crypto_key_2: "Ledger unifié avec vos autres transactions",
    benefits_crypto_key_3: "Réglez votre Charge Card en crypto",
    benefits_crypto_key_4: "Settlement sécurisé et instantané",
    benefits_giftcard_badge: "Couche 1 · Produit d'entrée",
    benefits_giftcard_title: "Cartes Cadeaux",
    benefits_giftcard_amounts: "Montants : £10 à £200",
    benefits_giftcard_validity: "Validité : 24 mois",
    benefits_giftcard_network: "Réseau croisé : utilisable partout",
    benefits_giftcard_points: "1 point par £1 acheté",
    benefits_giftcard_more: "En savoir plus",
    benefits_cta_title: "Prêt à rejoindre l'écosystème ?",
    benefits_cta_desc: "Commencez gratuitement. Débloquez les couches au fur et à mesure.",
    benefits_cta_btn: "Créer mon compte gratuit",
    
    // Contact Page
    contact_badge: "Nous sommes là pour vous",
    contact_title: "Contactez-nous",
    contact_subtitle: "Une question, une suggestion ou envie de rejoindre le réseau ? Notre équipe vous répond sous 24h.",
    contact_info_title: "Nos coordonnées",
    contact_email: "Email",
    contact_phone: "Téléphone",
    contact_address: "Adresse",
    contact_hours_title: "Horaires de support",
    contact_hours: "Lundi - Vendredi : 9h - 18h\nSamedi : 10h - 16h\nDimanche : Fermé",
    contact_form_title: "Envoyez-nous un message",
    contact_name: "Nom complet",
    contact_name_placeholder: "Jean Dupont",
    contact_email_placeholder: "jean@example.com",
    contact_subject: "Sujet",
    contact_subject_general: "Question générale",
    contact_subject_support: "Support technique",
    contact_subject_merchant: "Devenir partenaire",
    contact_subject_press: "Presse & média",
    contact_subject_other: "Autre",
    contact_message: "Message",
    contact_message_placeholder: "Comment pouvons-nous vous aider ?",
    contact_send: "Envoyer le message",
    contact_success_title: "Message envoyé !",
    contact_success_desc: "Merci de nous avoir contacté. Notre équipe vous répondra dans les plus brefs délais.",
    contact_success_btn: "Retour à l'accueil",
    
    // Gift Cards Page
    giftcards_badge: "Le cadeau parfait",
    giftcards_title_1: "Cartes cadeaux",
    giftcards_title_2: "universelles",
    giftcards_subtitle: "Offrez la liberté de choisir. Nos cartes cadeaux sont valables chez tous les marchands du réseau habitué.",
    giftcards_amounts: "Montants disponibles",
    giftcards_how_badge: "Comment ça marche",
    giftcards_how_title: "Offrir en 4 étapes",
    giftcards_step_1: "Choisissez un montant",
    giftcards_step_2: "Payez par carte",
    giftcards_step_3: "Envoyez par email",
    giftcards_step_4: "Faites plaisir !",
    giftcards_feature_1: "Réseau croisé",
    giftcards_feature_1_desc: "Une carte émise chez un marchand est utilisable chez tous les autres.",
    giftcards_feature_2: "Livraison instantanée",
    giftcards_feature_2_desc: "Physique (imprimée au POS) ou digitale (email / SMS / app).",
    giftcards_feature_3: "Validité 24 mois",
    giftcards_feature_3_desc: "Pas de stress. Utilisable pendant 2 ans après émission.",
    giftcards_feature_4: "1 point par £1",
    giftcards_feature_4_desc: "Le destinataire gagne des points à chaque utilisation.",
    giftcards_occasions_badge: "Pour toutes les occasions",
    giftcards_occasions_title: "Le cadeau qui fait toujours plaisir",
    giftcards_occasion_1: "Anniversaire",
    giftcards_occasion_2: "Noël",
    giftcards_occasion_3: "Fête des mères",
    giftcards_occasion_4: "Remerciement",
    giftcards_occasion_5: "Mariage",
    giftcards_occasion_6: "Crémaillère",
    giftcards_occasion_7: "Sans raison",
    giftcards_cta_title: "Prêt à faire plaisir ?",
    giftcards_cta_desc: "Créez un compte gratuit et offrez votre première carte cadeau en quelques clics.",
    giftcards_cta_btn: "Offrir une carte cadeau",
    
    // How It Works Page
    howitworks_badge: "Simple, rapide, efficace",
    howitworks_title: "Comment ça marche",
    howitworks_subtitle: "Découvrez comment habitué révolutionne la fidélité pour les consommateurs et les marchands.",
    howitworks_tab_consumer: "Je suis client",
    howitworks_tab_merchant: "Je suis marchand",
    howitworks_c_step_1: "Créez votre compte",
    howitworks_c_step_1_desc: "Inscription gratuite en 30 secondes. Pas de carte de crédit requise.",
    howitworks_c_step_1_detail: "Téléchargez l'app ou accédez au site, entrez votre email et c'est parti !",
    howitworks_c_step_2: "Scannez à chaque visite",
    howitworks_c_step_2_desc: "À la caisse, ouvrez l'app et scannez le QR code du marchand.",
    howitworks_c_step_2_detail: "Le scan prend moins d'une seconde. Pas de code à retenir, pas de carte à présenter.",
    howitworks_c_step_3: "Cumulez vos points",
    howitworks_c_step_3_desc: "Chaque scan vous rapporte des points automatiquement.",
    howitworks_c_step_3_detail: "En moyenne, gagnez 10 points par visite. Certains marchands offrent des bonus !",
    howitworks_c_step_4: "Convertissez en crédit",
    howitworks_c_step_4_desc: "100 points = £1. Convertissez à tout moment depuis votre portefeuille.",
    howitworks_c_step_4_detail: "Utilisez votre crédit chez n'importe quel marchand du réseau.",
    howitworks_c_step_5: "Offrez des cadeaux",
    howitworks_c_step_5_desc: "Achetez des cartes cadeaux pour vos proches.",
    howitworks_c_step_5_detail: "Valables partout dans le réseau, elles font toujours plaisir !",
    howitworks_m_step_1: "Inscrivez votre commerce",
    howitworks_m_step_1_desc: "Remplissez le formulaire en moins de 5 minutes.",
    howitworks_m_step_1_detail: "Nom, adresse, catégorie... C'est tout ce dont nous avons besoin.",
    howitworks_m_step_2: "Recevez votre QR code",
    howitworks_m_step_2_desc: "Unique à votre établissement, à afficher à la caisse.",
    howitworks_m_step_2_detail: "Nous l'envoyons par email et vous pouvez l'imprimer ou l'afficher sur tablette.",
    howitworks_m_step_3: "Accueillez vos clients",
    howitworks_m_step_3_desc: "Invitez-les à scanner votre QR code à chaque passage.",
    howitworks_m_step_3_detail: "Plus ils scannent, plus ils reviennent. C'est la magie de la fidélité !",
    howitworks_m_step_4: "Suivez vos performances",
    howitworks_m_step_4_desc: "Dashboard temps réel avec toutes vos statistiques.",
    howitworks_m_step_4_detail: "Visites, nouveaux clients, fidélité... Tout est visible en un coup d'œil.",
    howitworks_points_title: "La valeur de vos points",
    howitworks_points_pts: "points",
    howitworks_points_credit: "de crédit",
    howitworks_points_tip_1: "10 points minimum par visite",
    howitworks_points_tip_2: "Bonus x2 pour les membres Gold",
    howitworks_points_tip_3: "Points convertibles en cartes cadeaux",
    howitworks_faq_badge: "FAQ",
    howitworks_faq_title: "Questions fréquentes",
    howitworks_faq_1_q: "C'est vraiment gratuit ?",
    howitworks_faq_1_a: "Oui, totalement gratuit pour les consommateurs. Pas de frais cachés, pas d'abonnement.",
    howitworks_faq_2_q: "Mes points expirent-ils ?",
    howitworks_faq_2_a: "Non ! Vos points n'expirent jamais tant que votre compte reste actif.",
    howitworks_faq_3_q: "Puis-je utiliser mes points partout ?",
    howitworks_faq_3_a: "Oui, vos points sont universels et peuvent être convertis en crédit utilisable chez tous les marchands du réseau.",
    howitworks_faq_4_q: "Comment devenir marchand partenaire ?",
    howitworks_faq_4_a: "Inscrivez-vous en tant que marchand depuis l'app ou le site. L'intégration prend moins de 10 minutes et ne nécessite aucun matériel spécial.",
    howitworks_faq_5_q: "Les cartes cadeaux sont-elles remboursables ?",
    howitworks_faq_5_a: "Les cartes cadeaux ne sont pas remboursables mais n'expirent jamais et sont valables chez tous les marchands.",
    howitworks_cta_title: "Prêt à commencer ?",
    howitworks_cta_desc: "Rejoignez des milliers de membres qui cumulent déjà des récompenses.",
    howitworks_cta_btn: "Créer mon compte",
    howitworks_cta_merchants: "Voir les marchands",
    
    // Merchant Pricing Page
    pricing_badge: "Tarification transparente",
    pricing_title: "Tarifs Marchands",
    pricing_subtitle: "Commencez gratuitement pendant 90 jours. Évoluez selon vos besoins.",
    pricing_free: "Free",
    pricing_free_period: "90 jours",
    pricing_free_desc: "Testez habitué sans engagement",
    pricing_basic: "Basic",
    pricing_basic_period: "/mois",
    pricing_basic_desc: "Pour les commerces en croissance",
    pricing_advanced: "Advanced",
    pricing_advanced_period: "/mois",
    pricing_advanced_desc: "L'expérience complète",
    pricing_popular: "Populaire",
    pricing_free_f1: "QR code personnalisé",
    pricing_free_f2: "Dashboard basique",
    pricing_free_f3: "Cartes cadeaux (5% commission)",
    pricing_free_f4: "Support email",
    pricing_free_f5: "Jusqu'à 100 transactions/mois",
    pricing_basic_f1: "Tout Free +",
    pricing_basic_f2: "Dashboard avancé",
    pricing_basic_f3: "Analytics en temps réel",
    pricing_basic_f4: "Transactions illimitées",
    pricing_basic_f5: "Support prioritaire",
    pricing_basic_f6: "Exports CSV",
    pricing_basic_f7: "QR codes multiples",
    pricing_advanced_f1: "Tout Basic +",
    pricing_advanced_f2: "Acceptance Charge Card",
    pricing_advanced_f3: "Acceptance Crypto",
    pricing_advanced_f4: "Frais réduits (1.5%)",
    pricing_advanced_f5: "API access",
    pricing_advanced_f6: "Conciergerie dédiée",
    pricing_advanced_f7: "Campagnes marketing",
    pricing_advanced_f8: "Multi-établissements",
    pricing_cta_free: "Commencer gratuitement",
    pricing_cta_basic: "Choisir Basic",
    pricing_cta_advanced: "Choisir Advanced",
    pricing_compare_title: "Comparatif détaillé",
    pricing_compare_feature: "Fonctionnalité",
    pricing_compare_giftcards: "Cartes Cadeaux",
    pricing_compare_chargecard: "Charge Card",
    pricing_compare_crypto: "Crypto",
    pricing_compare_analytics: "Analytics",
    pricing_compare_support: "Support",
    pricing_compare_basic_analytics: "Basique",
    pricing_compare_advanced_analytics: "Avancé + API",
    pricing_compare_email: "Email",
    pricing_compare_dedicated: "Dédié",
    pricing_compare_included: "Inclus",
    pricing_commission_title: "Détail des commissions",
    pricing_commission_giftcard: "Commission à l'émission",
    pricing_commission_giftcard_note: "Breakage estimé : 12% à 24 mois",
    pricing_commission_chargecard: "Frais d'acceptance",
    pricing_commission_chargecard_note: "Inclus dans Advanced",
    pricing_commission_crypto: "Conversion + settlement",
    pricing_commission_crypto_note: "Vous recevez des GBP",
    pricing_cta_final_title: "Prêt à fidéliser vos clients ?",
    pricing_cta_final_desc: "90 jours gratuits. Installation en moins de 10 minutes. Aucun matériel supplémentaire requis.",
    pricing_cta_final_btn: "Devenir partenaire",
    
    // Network Page
    network_badge: "Notre réseau",
    network_title_suffix: "+ marchands à découvrir",
    network_subtitle: "Cafés, restaurants, boutiques, salons... Explorez notre réseau de commerces partenaires.",
    network_search: "Rechercher un commerce...",
    network_cat_all: "Tous",
    network_cat_cafe: "Cafés",
    network_cat_restaurant: "Restaurants",
    network_cat_boutique: "Boutiques",
    network_cat_salon: "Salons",
    network_cat_florist: "Fleuristes",
    network_no_results: "Aucun marchand trouvé",
    network_featured: "FEATURED",
    network_loyalty_reward: "Récompense fidélité",
    network_join_cta: "Rejoindre pour gagner des points",
    network_merchant_cta_title: "Vous êtes commerçant ?",
    network_merchant_cta_desc: "Rejoignez le réseau habitué et fidélisez vos clients sans effort. Installation en 10 minutes, sans matériel supplémentaire.",
    network_merchant_cta_btn: "Devenir partenaire",
    network_view_list: "Liste",
    network_view_map: "Carte",
    network_map_demo: "🗺️ Vue carte - Intégration Mapbox/Google Maps requise",
  },
  en: {
    // Splash
    splash_tagline: "The global gift card network",
    splash_enter: "Enter",
    splash_footer: "2000+ shops · Worldwide · By invitation",
    
    // Nav
    nav_layers: "The 3 layers",
    nav_gift_cards: "Gift Cards",
    nav_gift_cards_desc: "Give · Receive · Top up",
    nav_payment_card: "Payment Card",
    nav_payment_card_desc: "Pay · Monthly statement",
    nav_crypto: "Crypto Payment",
    nav_crypto_desc: "BTC · ETH · USDC · SOL · IKA",
    nav_discover: "Discover",
    nav_home: "Home",
    nav_network: "Global network",
    nav_loyalty: "Loyalty program",
    nav_about: "About",
    nav_contact: "Contact",
    nav_login: "Login",
    nav_gift: "Gift",
    nav_footer: "By invitation only",
    nav_global_shops: "2000+ shops · Worldwide",
    
    // Hero
    hero_badge: "Private network by invitation",
    hero_title_1: "One card.",
    hero_title_2: "One network.",
    hero_subtitle: "Gift card, loyalty card, payment card — it's all the same. Top up with fiat or crypto. Use in 2000+ shops worldwide.",
    hero_cta: "Gift a card",
    hero_cta_secondary: "Learn how it works",
    hero_received: "Already received a card?",
    hero_activate: "Activate it here",
    
    // Stats
    stats_shops: "Shops",
    stats_countries: "Countries",
    stats_members: "Members",
    
    // Sections
    section_concept: "The concept",
    section_one_card: "One card, three uses",
    section_one_card_desc: "No need to understand the difference — it's the same card.",
    
    card_gift: "Gift Card",
    card_gift_desc: "Give it to someone. It's their ticket into the network.",
    card_loyalty: "Loyalty Card",
    card_loyalty_desc: "Every purchase earns points. 100 pts = €1.",
    card_payment: "Payment Card",
    card_payment_desc: "Top it up and pay at any shop in the network.",
    
    // Join
    section_join: "How to join",
    section_invitation: "By invitation only",
    section_invitation_desc: "habitué is a private network. To become a member, someone must gift you a card.",
    
    join_step1_title: "Receive a gift card",
    join_step1_desc: "A friend, family member or shop gifts you a habitué card.",
    join_step2_title: "Activate your account",
    join_step2_desc: "Scan the QR code and create your account in 30 seconds.",
    join_step3_title: "Use & Share",
    join_step3_desc: "Spend, earn points, and gift cards to others.",
    
    no_card_yet: "Don't have a card yet?",
    request_invitation: "Request an invitation",
    
    // Top up
    section_topup: "Top up",
    section_topup_title: "Top up your way",
    section_topup_desc: "Your card is rechargeable anytime. Online, 24/7. With your bank card or cryptocurrencies.",
    topup_card: "Bank card",
    topup_card_desc: "Visa, Mastercard, Amex",
    topup_crypto: "Crypto",
    topup_crypto_desc: "BTC, ETH, USDC, SOL, IKA — auto conversion",
    topup_no_fees: "No fees on fiat top-ups. 1% on crypto conversions.",
    topup_amounts: "Top-up amounts",
    topup_custom: "Or custom amount",
    
    // Network
    section_network_badge: "Closed loop · Worldwide",
    section_network_title: "2000+ shops worldwide",
    section_network_desc: "Your habitué card works exclusively in our partner shop network — Paris, London, New York, Tokyo, Dubai and more.",
    explore_network: "Explore the global network",
    
    // Loyalty
    section_loyalty: "Loyalty",
    section_loyalty_title: "The more you use, the more you earn",
    points_per: "points",
    points_by: "per",
    points_spent: "spent",
    points_value: "credit on your card",
    points: "points",
    
    // Merchants
    section_merchants: "Merchants",
    section_merchants_title: "Join the network",
    section_merchants_desc: "Build customer loyalty effortlessly. Setup in 10 minutes. Accept habitué payments and attract a global clientele.",
    merchants_qr: "QR code to display — nothing else",
    merchants_dashboard: "Real-time dashboard",
    merchants_commission: "Commission only on sales",
    merchants_trial: "90 days free trial",
    become_partner: "Become a partner",
    pricing: "Pricing",
    trial: "Trial",
    trial_free: "90 days free",
    commission_note: "+ 5% commission on issued cards",
    
    // Final CTA
    final_title_1: "Spread the joy.",
    final_title_2: "Share habitué.",
    final_desc: "Gift a card to someone you love. It's their entry into the network.",
    final_cta: "Gift a card",
    have_card: "I already have a card",
    
    // Footer
    footer_tagline: "The global private gift card network.",
    footer_members: "Members",
    footer_activate: "Activate my card",
    footer_gift: "Gift a card",
    footer_shops: "Shops",
    footer_company: "Company",
    footer_merchants: "Merchants",
    footer_pricing: "Pricing",
    footer_partner: "Become a partner",
    footer_rights: "All rights reserved.",
    footer_love: "Made with ♥ in Paris",
    
    // Payment Card Page
    payment_layer: "Payment layer",
    payment_title_1: "Pay anywhere.",
    payment_title_2: "Frictionless.",
    payment_subtitle: "Your habitué card is also a payment card. Top it up and use it across the entire network.",
    payment_card_label: "PAYMENT CARD",
    balance: "BALANCE",
    payment_features: "Features",
    payment_features_title: "Simple and secure payments",
    payment_instant: "Instant payment",
    payment_instant_desc: "Scan a QR code or tap your phone to pay.",
    payment_secure: "Bank-level security",
    payment_secure_desc: "Encrypted transactions, no card details stored.",
    payment_statement: "Monthly statement",
    payment_statement_desc: "Track your spending with detailed reports.",
    payment_topup: "Easy top-up",
    payment_topup_desc: "Top up by card, transfer, or crypto.",
    payment_tiers: "Tiers",
    payment_tiers_title: "A tier for every use",
    limit: "Limit",
    tier_basic_payments: "Network payments",
    tier_2pts: "2 pts per £1 spent",
    tier_3pts: "3 pts per £1 spent",
    tier_4pts: "4 pts per £1 spent",
    tier_network_access: "Global network access",
    tier_priority_support: "Priority support",
    tier_exclusive_offers: "Exclusive offers",
    tier_concierge: "Concierge service",
    tier_vip_events: "VIP events",
    no_fees: "No fees",
    crypto_fee: "1% conversion fee",
    payment_cta_title: "Ready to pay with habitué?",
    payment_cta_desc: "Activate your card and start using it across the network.",
    activate_my_card: "Activate my card",
    
    // Crypto Page
    crypto_layer: "Crypto layer",
    crypto_title_1: "Your crypto.",
    crypto_title_2: "Your card.",
    crypto_subtitle: "Top up your habitué card with Bitcoin, Ethereum, USDC, Solana, or IKA. Auto-converted to £.",
    crypto_supported: "Accepted cryptos",
    crypto_supported_title: "5 cryptocurrencies available",
    crypto_btc_desc: "The standard",
    crypto_eth_desc: "Smart contracts",
    crypto_usdc_desc: "USD stablecoin",
    crypto_sol_desc: "Fast & cheap",
    crypto_ika_desc: "Native to habitué",
    crypto_how_it_works: "How it works",
    crypto_how_title: "Top up in 4 steps",
    crypto_step_1: "Choose your crypto",
    crypto_step_2: "Enter amount",
    crypto_step_3: "Send to address",
    crypto_step_4: "Instant credit",
    crypto_instant_conversion: "Instant conversion",
    crypto_instant_conversion_desc: "Your crypto is converted to £ at market rate.",
    crypto_secure: "Secure",
    crypto_secure_desc: "Transactions verified on the blockchain.",
    crypto_low_fees: "Low fees",
    crypto_low_fees_desc: "Only 1% conversion fee.",
    crypto_24_7: "Available 24/7",
    crypto_24_7_desc: "Top up anytime, anywhere.",
    crypto_conversion_title: "Automatic conversion",
    crypto_conversion_desc: "Your crypto is instantly converted to £ on your habitué card. No volatility, no surprises.",
    crypto_benefit_1: "Real-time market rates",
    crypto_benefit_2: "Instant credit to your card",
    crypto_benefit_3: "Full transaction history",
    crypto_fee_note: "Only 1% conversion fee",
    crypto_cta_title: "Ready to use your crypto?",
    crypto_cta_desc: "Activate your card and top up with your favorite cryptocurrencies.",
    
    // Loyalty Page
    loyalty_layer: "Loyalty program",
    loyalty_title_1: "Earn.",
    loyalty_title_2: "Every purchase.",
    loyalty_subtitle: "Every purchase in the habitué network earns you points. The more you use, the more you earn.",
    loyalty_how_points: "How do points work?",
    loyalty_credit: "credit",
    loyalty_credit_desc: "Usable across the network like cash.",
    loyalty_tiers: "Loyalty tiers",
    loyalty_tiers_title: "Three exclusive statuses",
    loyalty_earn_rate: "Earn rate",
    loyalty_member_b1: "Global network access",
    loyalty_member_b2: "Unlimited payments",
    loyalty_member_b3: "Transaction history",
    loyalty_reserve_b1: "Everything in Member, plus...",
    loyalty_reserve_b2: "Priority support",
    loyalty_reserve_b3: "Exclusive offers",
    loyalty_reserve_b4: "Early access invites",
    loyalty_founding_b1: "Everything in Reserve, plus...",
    loyalty_founding_b2: "Concierge service",
    loyalty_founding_b3: "VIP events",
    loyalty_founding_b4: "Exclusive Founding badge",
    loyalty_founding_b5: "Birthday gifts",
    loyalty_ways_earn: "Ways to earn",
    loyalty_ways_title: "Earn points easily",
    loyalty_way_1_title: "Network purchases",
    loyalty_way_1_desc: "Earn points on every purchase at our partners.",
    loyalty_way_2_title: "Gift cards",
    loyalty_way_2_desc: "50 pts bonus for each gift card sent.",
    loyalty_way_3_title: "Referrals",
    loyalty_way_3_desc: "100 pts when your referral activates their card.",
    loyalty_track_progress: "Track your progress",
    loyalty_your_points: "Your current points",
    loyalty_to_reserve: "points to Reserve",
    loyalty_cta_title: "Start earning now",
    loyalty_cta_desc: "Every purchase gets you closer to the next level.",
    
    // Gift Offer Page
    gift_badge: "Gift a card",
    gift_title_1: "Spread joy.",
    gift_title_2: "Gift network access.",
    gift_subtitle: "A habitué gift card is the key to a private network of exceptional shops.",
    gift_card_label: "GIFT CARD",
    gift_value: "VALUE",
    gift_feature_1: "Valid at 2000+ shops",
    gift_feature_2: "Instant email delivery",
    gift_feature_3: "24-month validity",
    gift_feature_4: "Recipient earns points",
    gift_step_1_title: "Choose an amount",
    gift_custom: "Other",
    gift_continue: "Continue",
    gift_step_2_title: "Recipient",
    gift_recipient_name: "Recipient name",
    gift_recipient_email: "Recipient email",
    gift_message: "Personal message (optional)",
    gift_message_placeholder: "Happy birthday! Hope you find something you love...",
    gift_back: "Back",
    gift_step_3_title: "Payment",
    gift_card_value: "Card value",
    gift_fees: "Fees",
    gift_free: "Free",
    gift_total: "Total",
    gift_card_number: "Card number",
    gift_expiry: "Expiry",
    gift_secure_payment: "Secure payment via Stripe",
    gift_send: "Send the gift",
    gift_note: "The recipient will receive an email with their card and a link to create their account.",
    
    // Activate Page
    activate_badge: "Activate a card",
    activate_title_1: "Activate your card.",
    activate_title_2: "Join the network.",
    activate_subtitle: "Received a habitué gift card? Activate it in seconds.",
    activate_step_1_label: "Scan",
    activate_step_2_label: "Create account",
    activate_step_3_label: "Done",
    activate_scan_title: "Scan your card",
    activate_scan_desc: "Scan the QR code on your gift card",
    activate_open_camera: "Open camera",
    activate_or: "or",
    activate_enter_code: "Enter card code",
    activate_verify: "Verify",
    activate_found_title: "Card found!",
    activate_found_desc: "Create your account to activate it.",
    activate_card_value: "Card value",
    activate_from: "From",
    activate_create_account: "Create your account",
    activate_name: "Your name",
    activate_email: "Your email",
    activate_password: "Password",
    activate_create_btn: "Create my account",
    activate_success_title: "Welcome to the network!",
    activate_success_desc: "Your card is now active.",
    activate_card_balance: "Card balance",
    activate_points: "Loyalty points",
    activate_tier: "Tier",
    activate_go_wallet: "Go to my wallet",
    activate_welcome_message: "Welcome to the habitué network!",
    activate_no_card: "Haven't received a card yet?",
    
    // Error messages
    error_enter_code: "Please enter an invitation code",
    error_invalid_code: "Invalid or expired invitation code",
    error_fill_all_fields: "Please fill in all required fields",
    error_password_min: "Password must be at least 6 characters",
    error_activation_failed: "Activation failed. Please try again.",
    loading: "Loading...",
    
    // About Page
    about_badge: "Our story",
    about_title_1: "Reinventing loyalty,",
    about_title_2: "together",
    about_desc: "habitué was born from a simple frustration: why have 15 loyalty cards when one could do it all? We created the network that brings your favorite shops together under one banner.",
    about_mission_badge: "Our mission",
    about_mission_title: "Creating connections between shops and their customers",
    about_mission_p1: "We believe loyalty shouldn't be complicated. No expiring points, no unreadable terms, no cards lost in a drawer.",
    about_mission_p2: "With habitué, every visit counts, every point has value, and every member is part of a community celebrating local commerce.",
    about_values_badge: "Our values",
    about_values_title: "What guides us",
    about_value_1_title: "Passion for local",
    about_value_1_desc: "We believe in the strength of local businesses and their ability to create connections.",
    about_value_2_title: "Transparency",
    about_value_2_desc: "No hidden fees, no obscure conditions. What is said is done.",
    about_value_3_title: "Simplicity",
    about_value_3_desc: "Invisible technology serving the experience. No unnecessary gadgets.",
    about_value_4_title: "Community",
    about_value_4_desc: "A network where every member, customer or merchant, finds their place and value.",
    about_timeline_badge: "Our journey",
    about_timeline_title: "An adventure begins",
    about_milestone_1_year: "2024",
    about_milestone_1_event: "Birth of the idea",
    about_milestone_1_desc: "Frustration with multiple loyalty cards",
    about_milestone_2_year: "2024",
    about_milestone_2_event: "First merchants",
    about_milestone_2_desc: "10 Parisian shops trust us",
    about_milestone_3_year: "2025",
    about_milestone_3_event: "Public launch",
    about_milestone_3_desc: "habitué opens its doors to everyone",
    about_milestone_4_year: "2025",
    about_milestone_4_event: "150+ merchants",
    about_milestone_4_desc: "The network expands across France",
    about_team_badge: "The team",
    about_team_title: "The faces behind habitué",
    about_cta_title: "Join the adventure",
    about_cta_desc: "Whether you're a customer or merchant, there's a place for you in the habitué network.",
    about_cta_member: "Become a member",
    about_cta_contact: "Contact us",
    about_stat_merchants: "Merchants",
    about_stat_members: "Members",
    about_stat_scans: "Scans",
    about_stat_satisfaction: "Satisfaction",
    
    // Benefits Page
    benefits_badge: "Complete ecosystem",
    benefits_title_1: "Three layers,",
    benefits_title_2: "one account",
    benefits_subtitle: "Gift cards · Proprietary Charge Card · Crypto payment. A complete platform for members and merchants.",
    benefits_tab_loyalty: "Loyalty",
    benefits_tab_card: "Charge Card",
    benefits_tab_crypto: "Crypto",
    benefits_how_earn: "How to earn points",
    benefits_pts_network: "At habitué merchants",
    benefits_pts_elsewhere: "Everywhere else",
    benefits_pts_value: "Usable credit",
    benefits_tier_member: "Your entry into the network",
    benefits_tier_reserve: "For loyal regulars",
    benefits_tier_founding: "The elite of the habitué network",
    benefits_exclusive: "Exclusive",
    benefits_card_hero_badge: "Layer 2 · Proprietary network",
    benefits_card_title: "habitué Charge Card",
    benefits_card_desc: "Proprietary payment card. Full balance due monthly. No revolving credit, no interest rates.",
    benefits_card_obsidian: "Premium matte black",
    benefits_card_creme: "Timeless elegance",
    benefits_card_forest: "British Racing Green",
    benefits_card_gold: "Metal · Founders Edition",
    benefits_card_limited: "Limited",
    benefits_card_feature_1: "Global network",
    benefits_card_feature_1_desc: "Acceptance via acquisition partnerships. Not Visa/Mastercard.",
    benefits_card_feature_2: "No debt",
    benefits_card_feature_2_desc: "Charge card — full balance due monthly. Zero interest.",
    benefits_card_feature_3: "Competitive FX",
    benefits_card_feature_3_desc: "1.5% margin on non-GBP transactions.",
    benefits_card_fees_title: "Annual fees",
    benefits_card_fees_standard: "Standard",
    benefits_card_fees_gold: "Gold Metal",
    benefits_card_fees_merchant: "Merchant acceptance fees: 1.5% – 2.0%",
    benefits_crypto_badge: "Layer 3 · Zero merchant exposure",
    benefits_crypto_title: "Crypto Payment",
    benefits_crypto_desc: "Pay in crypto, merchant receives GBP. Instant conversion at point of sale.",
    benefits_crypto_supported: "Accepted cryptos",
    benefits_crypto_btc: "The standard",
    benefits_crypto_eth: "Smart contracts",
    benefits_crypto_usdc: "USD stablecoin",
    benefits_crypto_sol: "Fast & cheap",
    benefits_crypto_how_title: "How it works",
    benefits_crypto_step_1: "You pay",
    benefits_crypto_step_1_desc: "In BTC, ETH or USDC from your wallet",
    benefits_crypto_step_2: "Conversion",
    benefits_crypto_step_2_desc: "Instant to GBP at market rate",
    benefits_crypto_step_3: "Merchant receives",
    benefits_crypto_step_3_desc: "British pounds, zero volatility",
    benefits_crypto_key_1: "Same points rate as fiat payment",
    benefits_crypto_key_2: "Unified ledger with your other transactions",
    benefits_crypto_key_3: "Pay your Charge Card in crypto",
    benefits_crypto_key_4: "Secure and instant settlement",
    benefits_giftcard_badge: "Layer 1 · Entry product",
    benefits_giftcard_title: "Gift Cards",
    benefits_giftcard_amounts: "Amounts: £10 to £200",
    benefits_giftcard_validity: "Validity: 24 months",
    benefits_giftcard_network: "Cross-network: usable everywhere",
    benefits_giftcard_points: "1 point per £1 purchased",
    benefits_giftcard_more: "Learn more",
    benefits_cta_title: "Ready to join the ecosystem?",
    benefits_cta_desc: "Start for free. Unlock layers as you go.",
    benefits_cta_btn: "Create my free account",
    
    // Contact Page
    contact_badge: "We're here for you",
    contact_title: "Contact us",
    contact_subtitle: "A question, suggestion, or want to join the network? Our team responds within 24 hours.",
    contact_info_title: "Our contact details",
    contact_email: "Email",
    contact_phone: "Phone",
    contact_address: "Address",
    contact_hours_title: "Support hours",
    contact_hours: "Monday - Friday: 9am - 6pm\nSaturday: 10am - 4pm\nSunday: Closed",
    contact_form_title: "Send us a message",
    contact_name: "Full name",
    contact_name_placeholder: "John Smith",
    contact_email_placeholder: "john@example.com",
    contact_subject: "Subject",
    contact_subject_general: "General question",
    contact_subject_support: "Technical support",
    contact_subject_merchant: "Become a partner",
    contact_subject_press: "Press & media",
    contact_subject_other: "Other",
    contact_message: "Message",
    contact_message_placeholder: "How can we help you?",
    contact_send: "Send message",
    contact_success_title: "Message sent!",
    contact_success_desc: "Thank you for contacting us. Our team will respond as soon as possible.",
    contact_success_btn: "Back to home",
    
    // Gift Cards Page
    giftcards_badge: "The perfect gift",
    giftcards_title_1: "Universal",
    giftcards_title_2: "gift cards",
    giftcards_subtitle: "Give the freedom to choose. Our gift cards are valid at all merchants in the habitué network.",
    giftcards_amounts: "Available amounts",
    giftcards_how_badge: "How it works",
    giftcards_how_title: "Gift in 4 steps",
    giftcards_step_1: "Choose an amount",
    giftcards_step_2: "Pay by card",
    giftcards_step_3: "Send by email",
    giftcards_step_4: "Spread joy!",
    giftcards_feature_1: "Cross-network",
    giftcards_feature_1_desc: "A card issued at one merchant is usable at all others.",
    giftcards_feature_2: "Instant delivery",
    giftcards_feature_2_desc: "Physical (printed at POS) or digital (email / SMS / app).",
    giftcards_feature_3: "24-month validity",
    giftcards_feature_3_desc: "No stress. Usable for 2 years after issue.",
    giftcards_feature_4: "1 point per £1",
    giftcards_feature_4_desc: "The recipient earns points with each use.",
    giftcards_occasions_badge: "For all occasions",
    giftcards_occasions_title: "The gift that always delights",
    giftcards_occasion_1: "Birthday",
    giftcards_occasion_2: "Christmas",
    giftcards_occasion_3: "Mother's Day",
    giftcards_occasion_4: "Thank you",
    giftcards_occasion_5: "Wedding",
    giftcards_occasion_6: "Housewarming",
    giftcards_occasion_7: "Just because",
    giftcards_cta_title: "Ready to spread joy?",
    giftcards_cta_desc: "Create a free account and send your first gift card in a few clicks.",
    giftcards_cta_btn: "Gift a card",
    
    // How It Works Page
    howitworks_badge: "Simple, fast, effective",
    howitworks_title: "How it works",
    howitworks_subtitle: "Discover how habitué revolutionizes loyalty for consumers and merchants.",
    howitworks_tab_consumer: "I'm a customer",
    howitworks_tab_merchant: "I'm a merchant",
    howitworks_c_step_1: "Create your account",
    howitworks_c_step_1_desc: "Free registration in 30 seconds. No credit card required.",
    howitworks_c_step_1_detail: "Download the app or access the site, enter your email and you're off!",
    howitworks_c_step_2: "Scan at each visit",
    howitworks_c_step_2_desc: "At checkout, open the app and scan the merchant's QR code.",
    howitworks_c_step_2_detail: "Scanning takes less than a second. No code to remember, no card to present.",
    howitworks_c_step_3: "Accumulate your points",
    howitworks_c_step_3_desc: "Each scan earns you points automatically.",
    howitworks_c_step_3_detail: "On average, earn 10 points per visit. Some merchants offer bonuses!",
    howitworks_c_step_4: "Convert to credit",
    howitworks_c_step_4_desc: "100 points = £1. Convert anytime from your wallet.",
    howitworks_c_step_4_detail: "Use your credit at any merchant in the network.",
    howitworks_c_step_5: "Give gifts",
    howitworks_c_step_5_desc: "Buy gift cards for your loved ones.",
    howitworks_c_step_5_detail: "Valid everywhere in the network, they always bring joy!",
    howitworks_m_step_1: "Register your business",
    howitworks_m_step_1_desc: "Fill out the form in under 5 minutes.",
    howitworks_m_step_1_detail: "Name, address, category... That's all we need.",
    howitworks_m_step_2: "Receive your QR code",
    howitworks_m_step_2_desc: "Unique to your establishment, display at checkout.",
    howitworks_m_step_2_detail: "We send it by email and you can print it or display on tablet.",
    howitworks_m_step_3: "Welcome your customers",
    howitworks_m_step_3_desc: "Invite them to scan your QR code with each visit.",
    howitworks_m_step_3_detail: "The more they scan, the more they return. That's the magic of loyalty!",
    howitworks_m_step_4: "Track your performance",
    howitworks_m_step_4_desc: "Real-time dashboard with all your statistics.",
    howitworks_m_step_4_detail: "Visits, new customers, loyalty... Everything visible at a glance.",
    howitworks_points_title: "The value of your points",
    howitworks_points_pts: "points",
    howitworks_points_credit: "credit",
    howitworks_points_tip_1: "10 points minimum per visit",
    howitworks_points_tip_2: "x2 bonus for Gold members",
    howitworks_points_tip_3: "Points convertible to gift cards",
    howitworks_faq_badge: "FAQ",
    howitworks_faq_title: "Frequently asked questions",
    howitworks_faq_1_q: "Is it really free?",
    howitworks_faq_1_a: "Yes, completely free for consumers. No hidden fees, no subscription.",
    howitworks_faq_2_q: "Do my points expire?",
    howitworks_faq_2_a: "No! Your points never expire as long as your account remains active.",
    howitworks_faq_3_q: "Can I use my points everywhere?",
    howitworks_faq_3_a: "Yes, your points are universal and can be converted to credit usable at all network merchants.",
    howitworks_faq_4_q: "How do I become a partner merchant?",
    howitworks_faq_4_a: "Register as a merchant from the app or website. Integration takes less than 10 minutes and requires no special equipment.",
    howitworks_faq_5_q: "Are gift cards refundable?",
    howitworks_faq_5_a: "Gift cards are non-refundable but never expire and are valid at all merchants.",
    howitworks_cta_title: "Ready to start?",
    howitworks_cta_desc: "Join thousands of members already earning rewards.",
    howitworks_cta_btn: "Create my account",
    howitworks_cta_merchants: "View merchants",
    
    // Merchant Pricing Page
    pricing_badge: "Transparent pricing",
    pricing_title: "Merchant Pricing",
    pricing_subtitle: "Start free for 90 days. Scale as you need.",
    pricing_free: "Free",
    pricing_free_period: "90 days",
    pricing_free_desc: "Test habitué with no commitment",
    pricing_basic: "Basic",
    pricing_basic_period: "/month",
    pricing_basic_desc: "For growing businesses",
    pricing_advanced: "Advanced",
    pricing_advanced_period: "/month",
    pricing_advanced_desc: "The complete experience",
    pricing_popular: "Popular",
    pricing_free_f1: "Custom QR code",
    pricing_free_f2: "Basic dashboard",
    pricing_free_f3: "Gift cards (5% commission)",
    pricing_free_f4: "Email support",
    pricing_free_f5: "Up to 100 transactions/month",
    pricing_basic_f1: "Everything in Free +",
    pricing_basic_f2: "Advanced dashboard",
    pricing_basic_f3: "Real-time analytics",
    pricing_basic_f4: "Unlimited transactions",
    pricing_basic_f5: "Priority support",
    pricing_basic_f6: "CSV exports",
    pricing_basic_f7: "Multiple QR codes",
    pricing_advanced_f1: "Everything in Basic +",
    pricing_advanced_f2: "Charge Card acceptance",
    pricing_advanced_f3: "Crypto acceptance",
    pricing_advanced_f4: "Reduced fees (1.5%)",
    pricing_advanced_f5: "API access",
    pricing_advanced_f6: "Dedicated concierge",
    pricing_advanced_f7: "Marketing campaigns",
    pricing_advanced_f8: "Multi-location",
    pricing_cta_free: "Start for free",
    pricing_cta_basic: "Choose Basic",
    pricing_cta_advanced: "Choose Advanced",
    pricing_compare_title: "Detailed comparison",
    pricing_compare_feature: "Feature",
    pricing_compare_giftcards: "Gift Cards",
    pricing_compare_chargecard: "Charge Card",
    pricing_compare_crypto: "Crypto",
    pricing_compare_analytics: "Analytics",
    pricing_compare_support: "Support",
    pricing_compare_basic_analytics: "Basic",
    pricing_compare_advanced_analytics: "Advanced + API",
    pricing_compare_email: "Email",
    pricing_compare_dedicated: "Dedicated",
    pricing_compare_included: "Included",
    pricing_commission_title: "Commission details",
    pricing_commission_giftcard: "Commission on issuance",
    pricing_commission_giftcard_note: "Estimated breakage: 12% at 24 months",
    pricing_commission_chargecard: "Acceptance fees",
    pricing_commission_chargecard_note: "Included in Advanced",
    pricing_commission_crypto: "Conversion + settlement",
    pricing_commission_crypto_note: "You receive GBP",
    pricing_cta_final_title: "Ready to build customer loyalty?",
    pricing_cta_final_desc: "90 days free. Setup in under 10 minutes. No additional equipment required.",
    pricing_cta_final_btn: "Become a partner",
    
    // Network Page
    network_badge: "Our network",
    network_title_suffix: "+ merchants to discover",
    network_subtitle: "Cafés, restaurants, boutiques, salons... Explore our network of partner shops.",
    network_search: "Search for a shop...",
    network_cat_all: "All",
    network_cat_cafe: "Cafés",
    network_cat_restaurant: "Restaurants",
    network_cat_boutique: "Boutiques",
    network_cat_salon: "Salons",
    network_cat_florist: "Florists",
    network_no_results: "No merchants found",
    network_featured: "FEATURED",
    network_loyalty_reward: "Loyalty reward",
    network_join_cta: "Join to earn points",
    network_merchant_cta_title: "Are you a merchant?",
    network_merchant_cta_desc: "Join the habitué network and build customer loyalty effortlessly. Setup in 10 minutes, no additional equipment.",
    network_merchant_cta_btn: "Become a partner",
    network_view_list: "List",
    network_view_map: "Map",
    network_map_demo: "🗺️ Map view - Mapbox/Google Maps integration required",
  }
};

export const LanguageProvider = ({ children }) => {
  // Initialize language synchronously from localStorage to avoid flash
  const [language, setLanguage] = useState(() => {
    if (typeof window !== 'undefined') {
      const savedLang = localStorage.getItem('habitue-lang');
      if (savedLang) return savedLang;
      const browserLang = navigator.language.slice(0, 2);
      return browserLang === 'en' ? 'en' : 'fr';
    }
    return 'fr';
  });

  const toggleLanguage = () => {
    const newLang = language === 'fr' ? 'en' : 'fr';
    setLanguage(newLang);
    localStorage.setItem('habitue-lang', newLang);
    // Dispatch custom event to trigger re-renders in components that need it
    window.dispatchEvent(new Event('languageChange'));
  };

  const t = (key) => {
    return translations[language][key] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
